import { useState, useMemo } from 'react'

import EditIcon from '@mui/icons-material/Edit'
import SearchIcon from '@mui/icons-material/Search'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import {
  GridRenderCellParams,
  GridFilterItem,
  GridSortModel,
} from '@mui/x-data-grid'
import DataTable, { ColumnItemProps } from 'components/DataTable'
import { ROUTES } from 'constants/routes'
import { useNavigate } from 'react-router-dom'

import Delete from './delete'

export default function CommercialUnits() {
  const navigate = useNavigate()

  const [deleteConfirmation, setDeleteConfirmation] = useState<
    CommercialUnit | undefined
  >()

  const [filterOptions, setFilterOptions] = useState<GridFilterItem[]>([])
  const [sortOptions, setSortOptions] = useState<GridSortModel>([])

  const columns = useMemo<ColumnItemProps[]>(
    () => [
      { field: 'name', headerName: 'Nome', flex: 1 },
      { field: 'fantasy_name', headerName: 'Nome fantasia', flex: 1 },
      { field: 'contact_name', headerName: 'Nome de contato', flex: 1 },
      { field: 'city', headerName: 'Cidade', flex: 1 },
      { field: 'uf', headerName: 'UF', width: 80 },
      { field: 'cell_phone', headerName: 'Celular', flex: 1 },
      { field: 'phone', headerName: 'Telefone', flex: 1 },
      {
        field: 'actions',
        headerName: 'Ações',
        width: 80,
        sortable: false,
        exclude: true,
        renderCell: (params: GridRenderCellParams<CommercialUnit>) => {
          return (
            <>
              <SearchIcon
                onClick={() => {
                  navigate(ROUTES.COMMERCIAL_UNITS.VIEW(params.row.id))
                }}
              />
              <EditIcon
                onClick={() => {
                  navigate(ROUTES.COMMERCIAL_UNITS.EDIT(params.row.id))
                }}
              />
            </>
          )
        },
      },
    ],
    [navigate],
  )

  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth={false}>
          <Box>
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
              }}
            >
              <Typography sx={{ m: 1 }} variant="h4">
                Unidades Comerciais
              </Typography>

              <Box sx={{ m: 1 }}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    navigate(ROUTES.COMMERCIAL_UNITS.CREATE)
                  }}
                >
                  Adicionar
                </Button>
              </Box>
            </Box>
          </Box>

          <Card sx={{ mt: 3 }}>
            <CardContent>
              <DataTable
                entity="CommercialUnit"
                source="commercialUnit"
                columns={columns}
                filterMode="server"
                onFilterModelChange={(newValue) => {
                  setFilterOptions(newValue.items)
                }}
                onSortModelChange={(newValue) => {
                  setSortOptions(newValue)
                }}
                likeParameters={filterOptions}
                sortParameters={sortOptions}
              />
            </CardContent>
          </Card>
        </Container>
      </Box>

      <Delete
        opened={!!deleteConfirmation}
        closeModal={() => setDeleteConfirmation(undefined)}
        commercialUnit={deleteConfirmation as CommercialUnit}
      />
    </>
  )
}
